<script>
import { mapActions, mapState, mapGetters } from "vuex";

import CustomDialog from "@/components/_Shared/Dialog";

import StoredCreditCard from "./StoredCreditCard";
import NewCreditCard from "./NewCreditCard";

export default {
  components: {
    StoredCreditCard,
    NewCreditCard,
    CustomDialog
  },

  data() {
    return {
      newCreditCard: false,
      preloader: false,
      cantPay: true,
      dialog: false
    };
  },

  methods: {
    ...mapActions("payable", [
      "resetPayment",
      "setPaymentType",
      "createOnGateway",
      "createPayment"
    ]),

    async returnPaymentOption() {
      if (!this.newCreditCard) {
        return this.resetPayment();
      }

      await this.updatePaymentType("STORED_CREDIT_CARD");

      this.newCreditCard = false;
    },

    async updatePaymentType(type) {
      await this.setPaymentType(type);
    },

    updateCanPay(canPay) {
      this.cantPay = !canPay;
    },

    async submit() {
      this.preloader = true;

      try {
        if (this.notCreatedOnGateway) {
          await this.createOnGateway();
        } else {
          await this.createPayment();
        }
      } catch (e) {
        this.error = e;
      }

      this.preloader = false;
    }
  },

  computed: {
    ...mapState("payable", [
      "preloaderCreditCards",
      "creditCards",
      "oldCreditCards"
    ]),
    ...mapGetters("payable", ["notCreatedOnGateway"])
  },

  async mounted() {
    if (!this.creditCards.length) {
      await this.updatePaymentType("CREDIT_CARD");
    }
  }
};
</script>

<template>
  <div>
    <div class="header">
      <img class="arrow" src="/static/arrow-prev.svg" @click="returnPaymentOption" />
      <h3>CARTÃO DE CRÉDITO</h3>
    </div>

    <transition name="zoom" mode="out-in">
      <NewCreditCard v-if="newCreditCard || !creditCards.length" />

      <div v-else>
        <StoredCreditCard v-if="!newCreditCard && creditCards.length" @updateCanPay="updateCanPay"/>

        <div class="buttons">
          <button class="btn btn-pink-ouline" @click="newCreditCard = true && updatePaymentType('CREDIT_CARD')">
            Pagar com outro cartão
          </button>

          <button
            class="submit-button" @click="submit"
            :class="{ 'button-disabled': cantPay, 'button-loading': preloader }"
            :disabled="cantPay"
          >
            <span>Pagar agora</span>
          </button>
        </div>
      </div>
    </transition>

    <custom-dialog
      :visible="dialog"
      icon="/static/icon-alert-purple.svg"
      title="Atualização sobre o pagamento via cartões de crédito salvos"
    >
      <template slot="body">
        <p>
          A empresa conhecida por Moip (Antigo Wirecard Brasil) foi adquirida pelo PagSeguro. Com essa fusão, o Moip está sendo descontinuado e estamos realizando a migração dos pagamentos via cartão de crédito para utilizar as soluções oferecidas pelo PagSeguro.
        </p>
        <p>
          <b>Ok, mas porque não estou vendo mais os meus cartões de crédito salvos?</b>
        </p>
        <p>
          Ao salvar um cartão de crédito para facilitar o processo de compras futuras, os dados que você informou são criptografados e apenas o meio de pagamento (Moip) que processa a transação da sua compra tem acesso a eles.
        </p>
        <p>
          A migração que estamos realizando do Moip para o PagSeguro, não permite mover essas informações entre as duas plataformas. Por esse motivo, caso você tenha salvo algum cartão no passado será necessário fazê-lo novamente. Entendemos que isso possa ser um pouco chato, mas esse processo garante a maior e a melhor segurança possível pra você e o seu cartão.
        </p>
        <p>
          <b>Salvar o cartão no momento da compra não é obrigatório. Caso você o faça, é possível excluí-lo a qualquer momento.</b>
        </p>
        <hr />
        <p>Caso você tenha alguma dúvida entre em contato com o nosso suporte. O nosso atendimento é de segunda à sexta das 8h às 18h e aos sábado das 8h às 14h.</p>

        <div class="btn-group">
          <div class="btn bg-purple-outline" @click="dialog = false">Ok, entendi!</div>
        </div>
      </template>
    </custom-dialog>
  </div>
</template>

<style scoped>
div {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.header {
  position: relative;
}

.arrow {
  width: 28px;
  height: 28px;
  position: absolute;
  left: 0;
  top: -4px;
  border-radius: 28px;
  border: solid 2px #e2e2e2;
  opacity: 0.5;
  transition: opacity 0.25s ease-in-out;
  cursor: pointer;
}

.arrow:hover {
  opacity: 1;
}

h3 {
  width: 100%;
  text-align: center;
  margin-top: 0;
  margin-bottom: 16px;
  padding-bottom: 12px;
  font-weight: 500;
  border-bottom: solid 1px #603285;
}

.old-card {
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
}

.buttons {
  width: 100%;
  max-width: 400px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

button {
  margin: 16px 0 0;
}

.submit-button {
  height: 40px;
  padding: 0 16px;
  border: 0;
  outline: none;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #603285;
  border-radius: 4px;
  color: #fff;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.25s ease;
}

.submit-button:hover {
  background-color: var(--pink-dark);
}

.button-disabled {
  opacity: 0.25;
  cursor: default;
}

.button-loading:before {
  content: "";
  width: 12px;
  height: 12px;
  border-radius: 24px;
  background-clip: padding-box;
  border: rgba(255, 255, 255, 0.25) 2px solid;
  border-top-color: #fff;
  animation: animation-rotate 750ms linear infinite;
}

.button-loading span,
.button-loading:hover span,
.button-loading:active span {
  display: none;
}

.disabled {
  display: none;
}

.warning {
  margin-top: 12px;
  color: #af006b;
  font-size: 12px;
  margin-bottom: 4px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/_Shared/CheckoutMobile/Payment/PaymentOptions/CreditCard.vue